import { render, staticRenderFns } from "./DistributionOfDirectCosts.vue?vue&type=template&id=e3664adc"
import script from "./DistributionOfDirectCosts.vue?vue&type=script&lang=js"
export * from "./DistributionOfDirectCosts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports